import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { InputAdornment, TextField, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Link from '@material-ui/core/Link';
import { useHistory } from "react-router-dom";
interface splitval {
   id:string,
   role:string
}

interface PlannerFieldProps {
    parentClasses: ClassNameMap,
    setValue: any,
    value:string,
    labelText: string,
    lastElement?: boolean,
    description: string,
    newval:splitval[]
}

const PlannerLinkFeild: React.FC<PlannerFieldProps> = ({
    parentClasses,
    setValue,
    value,
    labelText,
    lastElement,
    description,
    newval,
}) => {
    const history = useHistory();
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };
    const locationredirect = (value:any):void =>{
        history.push('/settings/locations/edit/'+value)
        window.location.reload();
    }
    return (
        <div className={parentClasses.inputRowWithTopBorder}>
            <div className={parentClasses.labelText}> 
                <p>
                    Shared with <span></span>
                    {newval.map((x:any) => <span>
                       
                        <span onClick={(event) => locationredirect(x["0"].split("#")[1])} className="linkBtn">{x["0"].split("#")[0]}</span><span>{x["1"]}</span>
                       
                       
                    </span>)}
                </p>
            </div>  
        </div>
    );
}

export default PlannerLinkFeild;